export const ADMIN_PATHS = {
  ROOT: '/admin',
  ENROLLMENTS: 'enrollments',
  ORGANIZATIONS: 'organizations',
  ORGANIZATION_ID: ':organizationId',
  PROGRAMS: 'programs',
  PROGRAM_ID: ':programId',
  MAP: 'map',
  USERS: 'users',
  CREATE: 'create',
  USER_ID: ':userId',
  PROGRAM_ACTIVITY: 'programActivity',
  PROFILE: 'profile',
  PREFERENCES: 'preferences',
  GROWER_MANAGEMENT: 'grower-management',
  AGREEMENTS: 'agreements',
  AGREEMENT_TYPE: ':type',
  AGREEMENT_ID: ':agreementId',
  USER_FIELDS: 'fields',
  USER_FIELDS_ADD: 'add',
  USER_FIELDS_DRAW: 'draw',
  USER_FIELDS_UPLOAD: 'upload',
}

export const ADMIN_ROUTES = {
  ROOT: ADMIN_PATHS.ROOT,
  PROGRAM_DETAIL: [ADMIN_PATHS.ROOT, ADMIN_PATHS.PROGRAMS, ADMIN_PATHS.PROGRAM_ID].join('/'),
  PROGRAM_ORGANIZATION_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.PROGRAMS,
    ADMIN_PATHS.PROGRAM_ID,
    ADMIN_PATHS.ORGANIZATION_ID,
  ].join('/'),
  PROGRAM_ORGANIZATION_USER_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.PROGRAMS,
    ADMIN_PATHS.PROGRAM_ID,
    ADMIN_PATHS.ORGANIZATION_ID,
    ADMIN_PATHS.USER_ID,
  ].join('/'),
  PROGRAM_LIST: [ADMIN_PATHS.ROOT, ADMIN_PATHS.PROGRAMS].join('/'),
  ENROLLED_FIELDS_MAP: [ADMIN_PATHS.ROOT, ADMIN_PATHS.PROGRAMS, ADMIN_PATHS.MAP].join('/'),
  ENROLLMENTS_LIST: [ADMIN_PATHS.ROOT, ADMIN_PATHS.ENROLLMENTS].join('/'),
  GROWER_MANAGEMENT_LIST: [ADMIN_PATHS.ROOT, ADMIN_PATHS.GROWER_MANAGEMENT].join('/'),
  AGREEMENT_TYPE_LIST: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.GROWER_MANAGEMENT,
    ADMIN_PATHS.AGREEMENT_TYPE,
  ].join('/'),
  AGREEMENT_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.GROWER_MANAGEMENT,
    ADMIN_PATHS.AGREEMENT_TYPE,
    ADMIN_PATHS.AGREEMENT_ID,
  ].join('/'),
  ORGANIZATION_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.ORGANIZATIONS,
    ADMIN_PATHS.ORGANIZATION_ID,
  ].join('/'),
  ORGANIZATION_DETAIL_USERS: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.ORGANIZATIONS,
    ADMIN_PATHS.ORGANIZATION_ID,
    ADMIN_PATHS.USERS,
  ].join('/'),
  ORGANIZATION_DETAIL_USER_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.ORGANIZATIONS,
    ADMIN_PATHS.ORGANIZATION_ID,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
  ].join('/'),
  ORGANIZATION_DETAIL_PROGRAMS: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.ORGANIZATIONS,
    ADMIN_PATHS.ORGANIZATION_ID,
    ADMIN_PATHS.PROGRAMS,
  ].join('/'),
  ORGANIZATION_DETAIL_PROGRAMS_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.ORGANIZATIONS,
    ADMIN_PATHS.ORGANIZATION_ID,
    ADMIN_PATHS.PROGRAMS,
    ADMIN_PATHS.PROGRAM_ID,
  ].join('/'),
  ORGANIZATION_LIST: [ADMIN_PATHS.ROOT, ADMIN_PATHS.ORGANIZATIONS].join('/'),
  USER_CREATE: [ADMIN_PATHS.ROOT, ADMIN_PATHS.USERS, ADMIN_PATHS.CREATE].join('/'),
  USER_DETAIL: [ADMIN_PATHS.ROOT, ADMIN_PATHS.USERS, ADMIN_PATHS.USER_ID].join('/'),
  USER_FIELDS: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.USER_FIELDS,
  ].join('/'),
  USER_PROGRAMS: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.PROGRAM_ACTIVITY,
  ].join('/'),
  USER_PROFILE: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.PROFILE,
  ].join('/'),
  USER_PREFERENCES: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.PREFERENCES,
  ].join('/'),
  USER_AGREEMENTS: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.AGREEMENTS,
  ].join('/'),
  USER_AGREEMENT_DETAIL: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.AGREEMENTS,
    ADMIN_PATHS.AGREEMENT_ID,
  ].join('/'),
  USER_FIELDS_ADD: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.USER_FIELDS,
    ADMIN_PATHS.USER_FIELDS_ADD,
  ].join('/'),
  USER_FIELDS_DRAW: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.USER_FIELDS,
    ADMIN_PATHS.USER_FIELDS_ADD,
    ADMIN_PATHS.USER_FIELDS_DRAW,
  ].join('/'),
  USER_FIELDS_UPLOAD: [
    ADMIN_PATHS.ROOT,
    ADMIN_PATHS.USERS,
    ADMIN_PATHS.USER_ID,
    ADMIN_PATHS.USER_FIELDS,
    ADMIN_PATHS.USER_FIELDS_ADD,
    ADMIN_PATHS.USER_FIELDS_UPLOAD,
  ].join('/'),
  USER_LIST: [ADMIN_PATHS.ROOT, ADMIN_PATHS.USERS].join('/'),
}

export type AdminProgramRouteParams = {
  programId: string
  organizationId?: string
  userId?: string
}
